import Stack from '@eversports/klimt-primitives/legacy/Stack'

import { EventBookableItem, EventSession } from '../ActivityDetails.types'
import checkHasOneSession from '../helpers/check-has-one-session'
import VenueInformation from '../VenueInformation/VenueInformation'

import InfoSection from './InfoSection'
import CancellationConditions from './InfoSection/CancellationConditions'
import Products from './Products'
import Schedule from './Schedule/Schedule'
import Trainers from './Trainers/Trainers'

interface Props {
  activity: EventBookableItem
  eventSessions: Array<EventSession>
}

const Overview = ({ activity, eventSessions }: Props) => {
  const { venue, trainers, cancellationCondition, registrationType } = activity

  const hasMultipleSessions = !checkHasOneSession(eventSessions)

  return (
    <Stack gap={{ xs: 3, md: 4 }} flex={{ md: 2 }} maxWidth={{ md: 700 }}>
      <Stack gap={{ xs: 1, md: 2 }}>
        <InfoSection activity={activity} eventSessions={eventSessions} />
        <Trainers trainers={trainers} venueType={venue.type} />
        <Products purchaseOptions={activity.purchaseOptions} registrationType={registrationType} />
        {hasMultipleSessions && <Schedule eventSessions={eventSessions} />}
        <VenueInformation venue={activity.venue} />
      </Stack>
      <CancellationConditions cancellationCondition={cancellationCondition} />
    </Stack>
  )
}

export default Overview
